export default __webpack_public_path__ + "mini-icon-android-10@2x.png";